export const betaContent = {
  hero: {
    title: "Be a Founding Family",
    subtitle: "Join us in building something special for families like yours",
    description: "We're inviting a small group of families to help shape FamilyCast from the ground up. This isn't just early access—it's a chance to build the family organization tool you've always wanted."
  },
  opportunity: {
    title: "Why This Matters",
    paragraphs: [
      "Every family deserves a central hub where schedules, chores, and important updates live together—visible to everyone, all the time. No more sticky notes falling off the fridge. No more \"I didn't see the text.\" No more being the family's human reminder system.",
      "We're building FamilyCast to solve these problems, but we can't do it alone. The best family tools are built with real families, for real families. That's where you come in."
    ]
  },
  whatsReady: {
    title: "What's Ready Now",
    subtitle: "These features are live and working today",
    features: [
      {
        iconName: "CalendarToday",
        title: "Family Calendar Hub",
        description: "Connect Google Calendar, Outlook, Apple Calendar, or any iCal feed. See everyone's schedule on one beautiful display."
      },
      {
        iconName: "Palette",
        title: "Custom Layouts",
        description: "Design exactly what your family sees. Drag, drop, resize—make it yours. Works on tablets, TVs, or any screen."
      },
      {
        iconName: "Cloud",
        title: "Weather & Utilities",
        description: "Local weather, clocks, countdowns to events, photo slideshows, and more. The info your family checks every day."
      },
      {
        iconName: "Devices",
        title: "Any Screen, Anywhere",
        description: "Run on a dedicated tablet in the kitchen, an HDMI stick on the living room TV, or just a browser tab."
      }
    ]
  },
  building: {
    title: "What We're Building Together",
    subtitle: "Help us shape these upcoming features",
    features: [
      {
        iconName: "EmojiEvents",
        title: "Chore & Reward Board",
        description: "Assign chores, track completion, reward progress. Turn household responsibilities into something the whole family can see and celebrate.",
        status: "In Active Development"
      },
      {
        iconName: "Restaurant",
        title: "Meal Planning",
        description: "Plan weekly meals, display what's for dinner, generate shopping lists. End the daily \"what should we eat?\" conversation.",
        status: "In Active Development"
      }
    ],
    cta: "As an early tester, you'll help us design these features. Your feedback directly shapes what we build."
  },
  benefits: {
    title: "What You Get",
    items: [
      {
        iconName: "Star",
        title: "Free to Start",
        description: "Try everything at no cost during early access"
      },
      {
        iconName: "Discount",
        title: "Founding Family Pricing",
        description: "Lock in special rates that stick with you forever"
      },
      {
        iconName: "Forum",
        title: "Direct Line to Us",
        description: "Chat directly with the people building FamilyCast"
      },
      {
        iconName: "Redeem",
        title: "Founding Family Swag",
        description: "Exclusive gear for our earliest supporters"
      }
    ]
  },
  form: {
    title: "Get Early Access",
    subtitle: "Tell us a bit about your family and we'll be in touch",
    useCaseLabel: "What's your biggest family coordination challenge?",
    useCasePlaceholder: "Examples: missed appointments, chore battles, everyone asking \"what's for dinner?\", keeping grandparents in the loop...",
    submitButton: "Count Me In",
    submittingButton: "Sending...",
    successMessage: "You're on the list! We'll reach out soon to get you started.",
    errorMessage: "Something went wrong. Please try again or email us at support@familycast.app",
    consent: "By joining, you agree to receive occasional updates about our beta program and family-focused features. We respect your privacy and you can unsubscribe at any time."
  },
  pricing: {
    note: "When you're ready to go beyond the free tier: $9/month for 3 screens, +$3 for each additional screen. Early testers get exclusive discounts."
  }
};
